// use client: router.replace() touches window.location, which throws during a
// server render — the redirect can only run once hydrated.
'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

const BOARD_OF_DIRECTORS = '/about/corporate-profile/board-of-directors'

function ProfileRedirect() {
  const router = useRouter()

  useEffect(() => {
    router.replace(BOARD_OF_DIRECTORS)
  }, [router])

  // Emit a <meta http-equiv="refresh"> (React 19 hoists it into <head>) so the
  // redirect is baked into the static HTML and fires at first paint — no blank
  // page waiting for JS/hydration.
  return <meta httpEquiv="refresh" content={`0; url=${BOARD_OF_DIRECTORS}/`} />
}

export default ProfileRedirect
